import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import backendService from '../services/backendService';
import useAccessBadge, { LicenseCoarseLevels } from './useAccessBadge';

const TEST_PREP_FREE_LIMIT = 3;

export function useTestPrepAccess() {
  const { accessBadge: userAccessBadge, isFetched: isAccessBadgeFetched } =
    useAccessBadge();

  const { data: testPrepLessonCount, isFetched: isTestPrepCountFetched } =
    useQuery({
      queryKey: ['testPrepLessonCount'],
      queryFn: () => backendService.instance.users.getTestPrepLessonCount(),
      refetchInterval: 1000 * 60 * 5,
      staleTime: 1000 * 60 * 4,
    });

  const isReady = isAccessBadgeFetched && isTestPrepCountFetched;

  const hasTestPrepAccess = useMemo(() => {
    if (!isReady) return true; // default to "has access" while loading

    const isFreemium =
      userAccessBadge?.license.coarseLevel === LicenseCoarseLevels.freemium;
    if (!isFreemium) return true; // non-freemium always has access

    const currentCount = testPrepLessonCount ?? 0;
    return currentCount < TEST_PREP_FREE_LIMIT;
  }, [isReady, userAccessBadge, testPrepLessonCount]);

  return { hasTestPrepAccess, isReady, testPrepLessonCount: testPrepLessonCount ?? 0 };
}
